var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"footerbox"}},[_c('div',{attrs:{"id":"name"}},[_vm._v("Coding Profile Manager ")]),_c('center',[_c('hr',{staticStyle:{"width":"40%","color":"white","height":"2px"}})]),_c('div',{attrs:{"id":"copy"}},[_vm._v(" Developed By Vivek Kumar © 2023 All Rights Reserved ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }